<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M629.3 183c2.5 0 4.7-.9 6.4-2.5l70.1-70.1c4.3-4.2 4.3-8.5 0-12.8l-24.2-23c-1.7-1.7-3.8-2.6-6.4-2.6H348.7c-2.6 0-4.7.9-6.4 2.6l-23 23c-4.3 4.2-4.3 8.5 0 12.8l70.1 70.1c1.7 1.7 3.8 2.5 6.4 2.5h233.5zM296.4 506.9c4.2 4.3 8.5 4.3 12.8 0l70.1-70.1c1.7-1.7 2.6-3.8 2.6-6.4V198.3c0-2.5-.9-4.7-2.6-6.4l-70.1-70.1c-4.2-4.3-8.5-4.3-12.8 0l-23 23c-1.7 1.7-2.6 3.8-2.6 6.4v325.2c0 2.5.9 4.7 2.6 6.4l23 24.1zm419.6 0c3.4 4.3 7.2 4.3 11.5 0l24.2-24.2c1.7-1.7 2.5-3.8 2.5-6.4V151.1c0-2.5-.8-4.7-2.5-6.4l-24.2-23c-4.2-3.4-8.1-3.4-11.5 0l-70.1 70.1c-1.7 1.7-2.6 3.8-2.6 6.4v232.1c0 2.5.9 4.7 2.6 6.4l70.1 70.2zm-75.2 59.9c2.5 0 4.7-.9 6.4-2.6l47.2-45.9c4.2-4.2 4.2-8.5 0-12.8L644.7 457H384.4c-2.5 0-4.7.8-6.4 2.5l-47.2 45.9c-4.2 4.3-4.2 8.5 0 12.8l47.2 45.9c1.7 1.7 3.8 2.6 6.4 2.6h256.4zM716 903.5c3.4 4.2 7.2 4.2 11.5 0l24.2-24.2c1.7-1.7 2.5-3.8 2.5-6.4V546.4c0-2.6-.8-4.7-2.5-6.4l-24.2-23c-4.2-3.4-8.1-3.4-11.5 0l-70.1 70.1c-1.7 1.7-2.6 3.8-2.6 6.4V827c0 2.5.9 4.7 2.6 6.4l70.1 70.1zM675.2 952c2.6 0 4.7-.8 6.4-2.5l24.2-24.2c3.4-3.4 3.4-7.2 0-11.5l-70.1-70.1c-1.7-1.7-3.8-2.6-6.4-2.6H398.4l-26.8 1.3c-2.5 0-4.7.9-6.4 2.6l-91.8 91.8c-3.4 3.4-4.5 6.8-3.2 10.2 1.3 3.4 4 5.1 8.3 5.1h396.7zm0 0"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
